module.exports = __webpack_public_path__ + "static/media/Coast12.cc95947a.jpg";